const weight = {
    thin: 100,
    extraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
};
//TODO:: lineHeight will be changed after discussion.
const lineHeight = [
    '0.75rem',
    '0.875rem',
    '1rem',
    '1.125rem',
    '1.25rem',
    '1.375rem',
    '1.5rem',
    '1.625rem',
    '1.75rem',
    '1.875rem',
    '2rem',
    '2.125rem',
    '2.25rem',
    '2.375rem',
    '2.5rem',
    '2.625rem',
    '2.75rem',
    '2.875rem',
    '3rem',
];
const desktop = {
    display: {
        d1: '64px',
        d2: '48px',
    },
    heading: {
        h1: '40px',
        h2: '36px',
        h3: '32px',
        h4: '28px',
        h5: '24px',
        h6: '20px',
        h7: '18px',
    },
    paragraph: {
        p1: '16px',
        p2: '14px',
        p3: '12px',
    },
};

const mobile = {
    display: {
        d1: '40px',
        d2: '34px',
    },
    heading: {
        h1: '30px',
        h2: '26px',
        h3: '24px',
        h4: '20px',
        h5: '18px',
        h6: '16px',
        h7: '14px',
    },
    paragraph: {
        p1: '14px',
        p2: '12px',
        p3: '10px',
    },
};

const typography = {
    type: {
        primary: 'IBMPlexSans-Regular',
    },
    size: {
        mobile,
        desktop,
    },
    weight,
    lineHeight,
};

export { typography };
